import { useHttpClient } from './httpClient.js';

const resource = 'sortitions';

export function fetchSortitionParams() {
	return useHttpClient().get(`/${resource}/params`);
}

export function createSortition(sortition) {
	return useHttpClient().post(`/${resource}`, { sortition });
}

export function fetchSortitions() {
	return useHttpClient().get(`/${resource}`);
}

export function fetchSortition(id) {
	return useHttpClient().get(`/${resource}/${id}`);
}

export function updateSortition(id, sortition) {
	return useHttpClient().put(`/${resource}/${id}`, { sortition });
}

export function destroySortition(id) {
	return useHttpClient().delete(`/${resource}/${id}`);
}
